import { Lookup } from '../lookup.interface';

export enum OutcomeReasonCodes {
  clientStopParticipating = 'client-stop-participating',
  clientDidNotAttendScheduledSessions = 'client-did-not-attend-scheduled-sessions',
  providerUnableToContactClient = 'provider-unable-to-contact-client',
  clientTransferredToAnotherProvider = 'client-transferred-to-another-provider',
  clientChoseToWithdraw = 'client-chose-to-withdraw',
  other = 'other',
}

export const OutcomeReasons: { [name: string]: Lookup } = {
  clientStopParticipating: {
    code: OutcomeReasonCodes.clientStopParticipating,
    displayValue: 'Client stopped participating',
  },
  clientDidNotAttendScheduledSessions: {
    code: OutcomeReasonCodes.clientDidNotAttendScheduledSessions,
    displayValue: 'Client did not attend scheduled sessions',
  },
  providerUnableToContactClient: {
    code: OutcomeReasonCodes.providerUnableToContactClient,
    displayValue: 'Provider unable to contact client',
  },
  clientTransferredToAnotherProvider: {
    code: OutcomeReasonCodes.clientTransferredToAnotherProvider,
    displayValue: 'Client transferred to another provider',
  },
  clientChoseToWithdraw: {
    code: OutcomeReasonCodes.clientChoseToWithdraw,
    displayValue: 'Client chose to withdraw',
  },
  other: {
    code: OutcomeReasonCodes.other,
    displayValue: 'Other - please specify',
  },
};
